
function CookieEinstellungenPage() {
  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <article className="max-w-[720px] mx-auto" style={{ lineHeight: 1.6 }}>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Cookies und Einwilligungen</h1>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Rechtsgrundlagen</h2>
        <p className="mb-4">
          <strong>Technisch notwendige Cookies/Dienste:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem, funktionsfähigem Betrieb).
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Eingesetzte Dienste</h2>

        <h3 className="text-xl font-semibold text-slate-900 mt-6 mb-3">PayPal Checkout</h3>
        <p className="mb-4">
          Anbieter: PayPal (Europe) S.à r.l. et Cie, S.C.A. Zweck: Anzeige/Abwicklung von Zahlungen über PayPal bzw. Kreditkarte.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Datenübermittlung in Drittländer</h2>
        <p className="mb-4">
          Bei Nutzung der Zahlungsdienste kann eine Übermittlung personenbezogener Daten in Drittstaaten außerhalb der EU/EWR erfolgen. Soweit erforderlich, erfolgt dies auf Grundlage geeigneter Garantien (z. B. EU-Standardvertragsklauseln). Details entnehmen Sie den Informationen der jeweiligen Anbieter.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Aktueller Stand</h2>
        <p className="mb-4">
          Zum Zeitpunkt der Veröffentlichung werden keine Statistik- oder Marketing-Tools eingesetzt. Sollten künftig zusätzliche Dienste hinzukommen, passen wir diese Erklärung entsprechend an.
        </p>

        <p className="text-sm text-slate-600 italic mt-8">Stand: 06.11.2025</p>
      </article>
    </div>
  );
}

export default CookieEinstellungenPage;
